import { IProjectConfiguration } from "../entities-generated/models/project/project-configuration";
import { ITimeBlockListing } from "../entities-generated/models/time-block/time-block-listing";
import { ApiClient } from "./shop-api-client";

class MyProjectApiClientClass {
  public clearAllPriceChangeNotifications() {
    return ApiClient.del<IProjectConfiguration>(`shop/my-project/price-alerts`);
  }

  public clearPriceChangeNotification(doorInstallationId: string) {
    return ApiClient.del<IProjectConfiguration>(`shop/install-plans/${doorInstallationId}/price-alert`);
  }

  public refreshPricing() {
    return ApiClient.get<IProjectConfiguration>(`shop/my-project/pricing/refresh`);
  }

  public removeDoorFromProject(doorInstallationId: string) {
    return ApiClient.patch<IProjectConfiguration>(`shop/install-plans/${doorInstallationId}/exclude`, {});
  }

  public restoreDoorToProject(doorInstallationId: string) {
    return ApiClient.patch<IProjectConfiguration>(`shop/install-plans/${doorInstallationId}/include`, {});
  }

  public getProjectInstallationDateOptions() {
    return ApiClient.get<ITimeBlockListing[]>(`shop/my-project/installation-dates`);
  }
}

export const MyProjectApiClient = new MyProjectApiClientClass();